<template>
  <div>
    <v-layout>
      <v-flex lg10 md9 sm12>
        <v-btn :to="{name: 'celendar-new'}" color="green">
          <v-icon>add</v-icon>
        </v-btn>
        <v-btn :to="{name: 'calendar-history'}">
          <v-icon>history</v-icon>
        </v-btn>
      </v-flex>
      <v-flex lg2 md3 sm12>
        <v-switch v-model="useUserCalendarColor" :label="$t('calendar.base.color_by_user')" hide-details
                  @change="switchCalendarColor"></v-switch>
      </v-flex>
    </v-layout>

    <v-dialog width="1000" v-model="showAddEvent">
      <v-card>
        <v-card-title class="headline" primary-title>
          {{ $t('calendar.base.select_event_type') }}
        </v-card-title>
        <v-container>
          <v-select v-model="newEventType" :items="schemas" item-text="name" item-value="id"
                    :label="$t('calendar.base.event_type')"></v-select>
          <v-btn color="green" @click="redirectToCreateEvent">OK</v-btn>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog width="80%" v-model="showHistoryEvent">
      <v-card>
        <v-card-title class="headline" primary-title>
          {{ $t('calendar.base.event_history') }} : {{ historyEvent.title }}
        </v-card-title>
        <v-container>
          <History :calendar-id="historyEvent.id" :users="users"></History>
        </v-container>
      </v-card>
    </v-dialog>

    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>

    <div v-else id="calednar">
      <v-layout style="margin-top: 3rem" wrap>
        <v-flex
            sm12
            lg3
            class="pa-3 mb-3 feature-pane"
        >
          <v-btn
              fab
              outline
              small
              absolute
              left
              color="primary"
              @click="$refs.calendar.prev()"
          >
            <v-icon dark>
              keyboard_arrow_left
            </v-icon>
          </v-btn>
          <v-btn
              fab
              outline
              small
              absolute
              right
              color="primary"
              @click="$refs.calendar.next()"
          >
            <v-icon
                dark
            >
              keyboard_arrow_right
            </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-container>
        <div min-height="600px">
              <v-layout>
                <v-flex>
                  <div v-if="mountedDone" style="min-height:500px">
                    <v-calendar
                        :now="today"
                        :value="today"
                        v-model="model"
                        color="primary"
                        @click:date="showPreAddEvent"
                        ref="calendar"
                        :dark="false"
                        locale="pl-Pl"
                        style="min-height: 400px"
                    >
                      <template v-slot:day="{ date }">
                        <template v-for="event in eventsMap[date]">
                          <v-menu
                              :key="event.id"
                              v-model="event.open"
                              full-width
                              offset-x
                          >
                            <template v-slot:activator="{ on }">
                              <v-sheet
                                  :style="getColorStyle(event)"
                                  v-if="!event.time"
                                  class="my-event"
                                  v-on="on"
                              >
                                <div class="wrapper">
                                  <div refs="eventTetxt" class="marquee">
                                    <span
                                        :style="getEventTextStyle(event)"> {{
                                        event.title + ' ' + event.scheduledAt.split(' ')[1]
                                      }} </span>
                                  </div>

                                </div>
                              </v-sheet>
                            </template>
                            <v-card
                                color="grey lighten-4"
                                min-width="350px"
                                flat
                            >
                              <v-toolbar
                                  :color="getColor(event)"
                                  dark
                              >
                                <v-toolbar-title v-html="`${event.title}`"></v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-menu offset-y>
                                  <template v-slot:activator="{ on }">
                                    <v-btn @click="menuEventClick($event, on)" icon>
                                      <v-icon>more_vert</v-icon>
                                    </v-btn>
                                  </template>
                                  <v-list>
                                    <v-list-tile @click="edit($event, event)">
                                      <v-list-tile-title>{{ $t('calendar.base.edit') }}</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="history(event)">
                                      <v-list-tile-title>{{ $t('calendar.base.history') }}</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="deleteEvent(event)">
                                      <v-list-tile-title>{{ $t('calendar.base.delete') }}</v-list-tile-title>
                                    </v-list-tile>
                                  </v-list>
                                </v-menu>
                              </v-toolbar>
                              <v-card-text>
                                <div>
                                  {{ $t('calendar.base.start') }}: {{ event.scheduledAt }}<br>
                                  {{ $t('calendar.base.end') }}: {{ event.finishedAt }}
                                </div>
                                <v-divider></v-divider>
                                <div style="margin:1rem 0rem;white-space: pre-line">
                                  {{ event.description }}
                                </div>
                              </v-card-text>
                              <v-card-actions>
                                <v-btn
                                    flat
                                    color="secondary"
                                >
                                  {{ $t('calendar.base.cancel') }}
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-menu>
                        </template>
                      </template>
                    </v-calendar>
                  </div>
                </v-flex>
              </v-layout>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import Messenger from "@/plugins/Messenger"
import History from './History'
import Cookies from 'js-cookie'

export default {
  name: "Index",
  components: {History},
  data() {
    return {
      showHistoryEvent: false,
      historyEvent: {},
      useUserCalendarColor: false,
      users: [],
      today: new Date().toISOString().slice(0, 19).replace('T', ' '),
      events: [],
      eventsT: [],
      loading: true,
      mountedDone: false,
      model: null,
      showAddEvent: false,
      schemas: [],
      newEventDate: null,
      newEventType: -1
    }
  },
  computed: {
    eventsMap() {
      const map = {}
      this.eventsT.forEach(e => (map[e.scheduledAt.split(" ")[0]] = map[e.scheduledAt.split(" ")[0]] || []).push(e))
      return map
    }
  },
  created() {
    this.useUserCalendarColor = Cookies.get('useUserCalendarColor') === 'true'
    let schemas = this.$http.get('schemas')
    let calendarSchemas = this.$http.get('calendar/schemas')
    let users = this.$http.get('/users')

    Promise.all([schemas, calendarSchemas, users]).then(data => {
      let idSchemas = data[1].data.map(cs => cs.schema_id)
      this.schemas = data[0].data.filter(schema => idSchemas.includes(schema.id))
      this.schemas = [{id: 0, name: this.$t('calendar.base.standard_event')}].concat(this.schemas)
      this.users = data[2].data
    }).catch(() => {
      Messenger.emitError(this.$t('calendar.base.cannot_download_data'))
    })
  },
  mounted() {
    this.loading = true
    this.$http.get('calendar').then(data => {
      const map = {}
      this.eventsT = data.data
      data.data.forEach(e => (map[e.scheduledAt.split(" ")[0]] = map[e.scheduledAt.split(" ")[0]] || []).push(e))
      this.loading = false
    }).catch(() => {
      Messenger.emitError(this.$t('calendar.base.cannot_download_data'))
    })
    this.mountedDone = true
  },
  methods: {
    switchCalendarColor($event) {
      Cookies.set('useUserCalendarColor', $event)
    },
    menuEventClick($event, on) {
      $event.stopPropagation()
      on.click($event)
    },
    edit($event, calendarEvent) {
      $event.stopPropagation()
      this.$router.push(`/calendar/${calendarEvent.id}/update`)
    },
    history(calendarEvent) {
      this.historyEvent = calendarEvent
      this.showHistoryEvent = true
    },
    deleteEvent(calendarEvent) {
      this.$http.delete(`calendar/${calendarEvent.id}`).then(() => {
        this.eventsT = this.eventsT.filter(el => el.id != calendarEvent.id)
        Messenger.emitSuccess(this.$t('calendar.base.event_deleted'))
      }).catch(() => Messenger.emitError(this.$t('calendar.base.cannot_delete_event')))
    },
    showPreAddEvent(date) {
      this.showAddEvent = true
      this.newEventDate = date
    },
    redirectToCreateEvent() {
      if (this.newEventType === -1) {
        Messenger.emitError(this.$t('calendar.base.select_event_type'))
        return
      }

      let queryParam = '?date=' + this.newEventDate.date

      if (this.newEventType === 0) {
        this.$router.push(`calendar/new/${queryParam}`)
        return
      }

      this.$router.push(`form/${this.newEventType}/fill/${queryParam}`)

    },
    invertColor(hex, bw) {
      if (hex.indexOf('#') === 0) {
        hex = hex.slice(1)
      }
      // convert 3-digit hex to 6-digits.
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
      }
      if (hex.length !== 6) {
        return '#000000'
      }
      var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16)
      if (bw) {
        // https://stackoverflow.com/a/3943023/112731
        return (r * 0.299 + g * 0.587 + b * 0.114) > 186
          ? '#000000'
          : '#FFFFFF'
      }
      // invert color components
      r = (255 - r).toString(16)
      g = (255 - g).toString(16)
      b = (255 - b).toString(16)
      // pad each with zeros and return
      return "#" + String(r).padStart(2, 0) + String(g).padStart(2, 0) + String(b).padStart(2, 0)
    },
    getColor(event) {
      if (this.useUserCalendarColor == true && event.event_data && event.event_data.user_color) {
        return event.event_data.user_color
      }

      if (event.event_data && event.event_data.color) {
        return event.event_data.color
      }

      return '#106011'
    },
    getClass: function () {
      return 'marquee'

    },
    getColorStyle(event) {
      let color = this.getColor(event)
      return ` background-color: ${color};\n` +
          '  color: #ffffff;\n' +
          '  border: 1px solid black;'
    },
    getEventTextStyle(event) {
      let color = this.getColor(event)
      let invertColor = this.invertColor(color, true)
      return `color:  ${invertColor};\n`
    }
  },
}
</script>

<style scoped>
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}

.wrapper {
  max-width: 100%;
  overflow: hidden;
  font-family: 'Times New Roman';
}

.marquee:hover {
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  animation: marquee 15s linear infinite;
}

.marquee p {
  display: inline-block;
}

@keyframes marquee {
  0% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(-65%, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
</style>